/*
 * rheincool — WhatsApp-Button (WhatsApp-Button-Handoff §2.4, §5)
 *
 * Zwei Aufgaben:
 *  1. Kopier-Aktion der Desktop-Variante. Für Nutzer ohne WhatsApp Web am
 *     Rechner ist die kopierte Nummer der einzige brauchbare Weg — deshalb
 *     ist das kein Komfort-Feature, sondern der eigentliche Zweck.
 *  2. Erwartungszeile an die Öffnungszeiten anpassen. Der Fahrplan ist
 *     derselbe wie beim Verfügbarkeitsindikator im Header (data-hours,
 *     Format "1-5:9-16"), gelesen über den gemeinsamen Helfer.
 *
 * Ohne JS bleibt die allgemeine Zeile stehen — sie ist nie falsch, nur
 * unspezifisch. Das ist die bessere Ausfallstufe als eine leere Zeile.
 */
(() => {
  'use strict';

  /* --- Kopieren --- */
  class RcWhatsappCopy extends HTMLElement {
    connectedCallback() {
      this.knopf = this.querySelector('[data-wa-copy]');
      this.status = this.querySelector('[data-wa-status]');
      const feld = this.querySelector('[data-wa-nummer]');
      if (!this.knopf || !feld) return;
      this.nummer = feld.dataset.waNummer || feld.textContent.trim();
      this.knopf.addEventListener('click', () => this.kopieren());
    }

    async kopieren() {
      let ok = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.nummer);
          ok = true;
        }
      } catch {
        ok = false;
      }
      /* Fallback ohne Clipboard-API: unsichtbares Feld, markieren, kopieren */
      if (!ok) ok = this.ueberFeld();

      /* Scheitert auch das — etwa ohne Nutzerfreigabe für die Zwischenablage —
         darf der Knopf nicht stumm bleiben. Dann wird die Nummer im Text
         markiert, und die Rückmeldung sagt, was der Nutzer jetzt tun muss.
         Ein Klick ohne jede Reaktion ist die schlechteste Variante. */
      if (!ok) {
        this.markieren();
        const hinweis = this.knopf.dataset.manual || '';
        if (this.status) this.status.textContent = hinweis;
        this.knopf.textContent = hinweis || this.knopf.textContent;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.knopf.textContent = this.knopf.dataset.label || '';
          if (this.status) this.status.textContent = '';
        }, 4000);
        return;
      }

      const fertig = this.knopf.dataset.done || '';
      const zurueck = this.knopf.dataset.label || this.knopf.textContent;
      this.knopf.textContent = fertig;
      this.knopf.classList.add('is-done');
      if (this.status) this.status.textContent = fertig;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.knopf.textContent = zurueck;
        this.knopf.classList.remove('is-done');
        if (this.status) this.status.textContent = '';
      }, 2000);
    }

    /* Nummer im sichtbaren Text markieren, damit Strg+C sie erwischt. */
    markieren() {
      const feld = this.querySelector('[data-wa-nummer]');
      if (!feld || !window.getSelection) return;
      const bereich = document.createRange();
      bereich.selectNodeContents(feld);
      const auswahl = window.getSelection();
      auswahl.removeAllRanges();
      auswahl.addRange(bereich);
    }

    ueberFeld() {
      const feld = document.createElement('input');
      feld.setAttribute('readonly', '');
      feld.value = this.nummer;
      feld.style.position = 'fixed';
      feld.style.opacity = '0';
      this.append(feld);
      feld.select();
      feld.setSelectionRange(0, this.nummer.length);
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch {
        ok = false;
      }
      feld.remove();
      return ok;
    }
  }
  if (!customElements.get('rc-whatsapp-copy')) {
    customElements.define('rc-whatsapp-copy', RcWhatsappCopy);
  }

  /* --- Erwartungszeile --- */
  document.querySelectorAll('[data-wa-hours]').forEach((el) => {
    const plan = window.rcOeffnung && window.rcOeffnung.fahrplan(el.dataset.waHours);
    if (!plan) return;
    const offen = window.rcOeffnung.istOffen(plan);
    const text = offen ? el.dataset.openText : el.dataset.closedText;
    if (text) el.textContent = text;
  });
})();
